<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Cursos</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <div class="margin">
          <vs-row vs-justify="left">
            <vs-row vs-align="flex-end" vs-justify="flex-end">
              <vs-button icon="unfold_more" @click="toggleAll" color="dark" type="border">
                Expandir/Ocultar - Todos
              </vs-button>
            </vs-row>
            <vs-col>
              <vs-collapse>
                <vs-collapse-item
                  v-for="(value, name) in courses"
                  :key="name"
                  :ref="name"
                  type="margin"
                  @click.native="closeChildrenCollapses(name)"
                >
                  <div slot="header">
                    <h3>{{ name }}</h3>
                  </div>

                  <div style="margin-top: 10px;">
                    <vs-collapse v-if="name === 'Graduação' || name === 'Técnico'">
                      <vs-collapse-item
                        v-for="(courseList, eixoName) in value"
                        :key="eixoName"
                        :ref="`eixo-${name}-${eixoName}`"      
                        @click.native="handleEixoClick(name, eixoName)"   
                      >
                        <div slot="header">
                          <h4>{{ eixoName }}</h4>
                        </div>

                        <div style="margin-top: 10px;">
                          <vs-card
                            class="event-course" actionable v-for="course in courseList"
                            :key="course.IDCLASSIFICACAO"
                          >
                            <div @click.stop="selectCourse(course)">
                              <vs-row vs-justify="space-between">
                                <vs-col vs-w="9" vs-xs="12">{{course.NOMECOMERCIAL}}</vs-col>
                                <vs-col vs-w="3" vs-xs="12" v-if="course.NUMPARCELAS">
                                  {{ course.NUMPARCELAS }}x de R${{(course.VALOR / course.NUMPARCELAS).toFixed(2)}}
                                </vs-col>
                                <vs-col vs-w="3" vs-xs="12" v-else>
                                  <p style="font-size: 0.85em;font-style: italic;">* Sem parcelamento padrão</p>
                                </vs-col>
                              </vs-row>
                            </div>
                          </vs-card>
                        </div>
                      </vs-collapse-item>
                    </vs-collapse>

                    <div v-else>
                      <vs-card
                        class="event-course" actionable v-for="course in value"
                        :key="course.IDCLASSIFICACAO"
                      >
                        <div @click.stop="selectCourse(course)"> <vs-row vs-justify="space-between">
                            <vs-col vs-w="9" vs-xs="12">{{course.NOMECOMERCIAL}}</vs-col>
                            <vs-col vs-w="3" vs-xs="12" v-if="course.NUMPARCELAS">
                              {{ course.NUMPARCELAS }}x de R${{(course.VALOR / course.NUMPARCELAS).toFixed(2)}}
                            </vs-col>
                            <vs-col vs-w="3" vs-xs="12" v-else>
                              <p style="font-size: 0.85em;font-style: italic;">* Sem parcelamento padrão</p>
                            </vs-col>
                          </vs-row>
                        </div>
                      </vs-card>
                    </div>

                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </vs-col>
          </vs-row>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CoursesService from "../services/courses";
import { updateDiscussion } from "../helpers";
import { bus } from "../main";

export default {
  name: "Courses",
  data: () => ({
    courses: {},
    selected: null,
  }),
  mounted() {
    this.$vs.loading({
      color: "danger",
    });
    bus.$emit("updateSteps", 0);
    new CoursesService()
      .fetchCourses()
      .then((res) => {
        const coursesList = res.data;

        const groupedCourses = coursesList.reduce((acc, course) => {
          const modality = course.MODALIDADE;
          const eixo = this.getEixoForCourse(course);

          if (!acc[modality]) {
            if (modality === 'Graduação' || modality === 'Técnico') {
              acc[modality] = {};
            } else {
              acc[modality] = [];
            }
          }

          if (modality === 'Graduação' || modality === 'Técnico') {
            if (!acc[modality][eixo]) {
              acc[modality][eixo] = [];
            }
            acc[modality][eixo].push(course);
          } else {
            acc[modality].push(course);
          }
          return acc;
        }, {});

        this.courses = groupedCourses;
        console.log(this.courses);
        this.$vs.loading.close();
      })
  },
  computed: {
    selectedTitle() {
      if (this.selected) {
        return `Você selecionou: ${this.selected.NOMECOMERCIAL}`;
      }
      return "";
    },
  },
  methods: {
    getEixoForCourse(course) {
      const courseName = course.NOMECOMERCIAL.toLowerCase();
      if (courseName.includes('enfermagem')) {
        return 'Eixo Saúde';
      }
      if (courseName.includes('informática') || courseName.includes('sistemas')) {
        return 'Eixo Tecnologia';
      }
      if (
        courseName.includes('administração') ||
        courseName.includes('contabilidade') ||
        courseName.includes('contábeis') ||
        courseName.includes('logística') ||
        courseName.includes('recursos humanos') ||
        courseName.includes('vendas') ||
        courseName.includes('segurança do trabalho') ||
        courseName.includes('gestão') ||
        courseName.includes('marketing') ||
        courseName.includes('gerenciais')
      ) {
        return 'Eixo Gestão de Negócios';
      }
      return 'Outros Cursos';
    },

    selectCourse(course) {
      this.$vs.loading({
        color: "danger",
      });
      updateDiscussion(`Selecionou Curso: ${course.NOMECOMERCIAL}`, {
        course,
      }).finally(() => {
        this.$router.push("/branches");
      });
    },

    handleEixoClick(parentName, eixoName) {
      const parentCollapse = this.$refs[parentName][0];
      const childCollapse = this.$refs[`eixo-${parentName}-${eixoName}`][0];

      if (parentCollapse && childCollapse) {
        const childContent = childCollapse.$el.querySelector('.vs-collapse-item--content');
        const onTransitionEnd = () => {
          parentCollapse.changeHeight();
          childContent.removeEventListener('transitionend', onTransitionEnd);
        };
        childContent.addEventListener('transitionend', onTransitionEnd);
      }
    },

    closeChildrenCollapses(parentRefName) {
      this.$nextTick(() => {
        const parentCollapse = this.$refs[parentRefName][0];
        if (parentCollapse && parentCollapse.maxHeight === '0px') {
          const eixos = this.courses[parentRefName];
          if (eixos) {
            Object.keys(eixos).forEach(eixoName => {
              const childRefName = `eixo-${parentRefName}-${eixoName}`;
              const childCollapse = this.$refs[childRefName][0];
              if (childCollapse && childCollapse.maxHeight !== '0px') {
                childCollapse.toggleContent();
              }
            });
          }
        }
      });
    },

    toggleAll() {
      const coursesRefs = Object.keys(this.courses);
      const shouldExpand = coursesRefs.some(
        (ref) => this.$refs[ref][0].maxHeight === "0px"
      );
      coursesRefs.forEach((ref) => {
        const collapseItem = this.$refs[ref][0];
        if (shouldExpand) {
          if (collapseItem.maxHeight === "0px") {
            collapseItem.toggleContent();
          }
        } else {
          collapseItem.toggleContent();
        }
      });
    },
  },
}
</script>

<style scoped>
.margin {
  margin-bottom: 10px;
}

.event-course {
  box-shadow: 0px 0px 2px 1px #888888;
}

.event-course:hover {
  font-weight: bold;
  box-shadow: 0px 0px 3.5px 2.5px #9B0E1C;
}

</style>
